import { queryClient, useMutation } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { isOrgScanningQueryKey } from './useIsOrgScanning';

/**
 * Scans all projects in the organization.
 * This is a GET even though it's a "mutation", technically this should be a POST or something though.
 */
function orgScanAll() {
  return get<void>(`/api/organization/scan`);
}

/**
 * Provides a mutation to scan all projects in the organization.
 * Note that the API accepts `ids` (to limit the scan to specific projects),
 * but we don't use this on the front-end, so this hook does not expose that functionality.
 */
export default function useOrgScanAll() {
  return useMutation({
    mutationFn: orgScanAll,
    onSuccess: () => {
      //  Ensure that the isOrgScanning query is invalidated and refetched
      queryClient.invalidateQueries(isOrgScanningQueryKey);
    },
  });
}
